import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-recruit_index_header_back",
  "use": "icon-recruit_index_header_back-usage",
  "viewBox": "0 0 10 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 18\" id=\"icon-recruit_index_header_back\"><path d=\"M.077 1.644 1.616 0 10 8.959 1.538 18 0 16.356 6.923 8.96z\" fill=\"#999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol